import { render, staticRenderFns } from "./PosCatalogGroups.vue?vue&type=template&id=b7f082fe&scoped=true"
import script from "./PosCatalogGroups.vue?vue&type=script&lang=js"
export * from "./PosCatalogGroups.vue?vue&type=script&lang=js"
import style0 from "./PosCatalogGroups.vue?vue&type=style&index=0&id=b7f082fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7f082fe",
  null
  
)

export default component.exports